// One Messages feed for a group (owner 2026-10-12): owner announcements,
// kudos, prize wins and joins, newest first. Before this they lived in an
// Announcements card above the tabs and a separate Activity tab.
//
// Each item carries `kind` + `id`, the same pair group_message_hides stores,
// so a "Hide" tick can be matched back to the item it hid.

export const messageKey = (kind, id) => `${kind}:${id}`

export function buildGroupMessages({ announcements = [], activity = [] } = {}) {
  const items = [
    ...(announcements || []).map((a) => ({ ...a, kind: 'announcement' })),
    ...(activity || []).map((a) => ({ ...a, kind: a.activity_type })),
  ].map((item) => ({ ...item, key: messageKey(item.kind, item.id) }))

  return items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
}

export function hiddenKeySet(hides) {
  return new Set((hides || []).map((h) => messageKey(h.item_kind, h.item_id)))
}

export function splitHidden(items, hiddenKeys) {
  const visible = []
  const hidden = []
  for (const item of items) {
    (hiddenKeys.has(item.key) ? hidden : visible).push(item)
  }
  return { visible, hidden }
}
